import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/dashboard', replace: true })
      return
    }

    const hasMenus = store.getters.menus && store.getters.menus.length > 0
    if (hasMenus) {
      next()
      return
    }

    try {
      await store.dispatch('user/getInfo')
      // 静态路由已注册，无需再 next({ ...to })，避免 NavigationRedirected 报错
      next()
    } catch (e) {
      await store.dispatch('user/resetToken')
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
    }
    return
  }

  if (whiteList.includes(to.path)) {
    next()
  } else {
    next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }
})

router.afterEach(() => {
  NProgress.done()
})
